"use client"

import { forwardRef, useState } from "react"
import styles from "./Input.module.css"

const Input = forwardRef(
  (
    {
      label,
      error,
      success,
      warning,
      helperText,
      placeholder,
      value,
      defaultValue,
      onChange,
      onFocus,
      onBlur,
      type = "text",
      disabled = false,
      readOnly = false,
      required = false,
      size = "medium",
      variant = "default",
      fullWidth = true,
      name,
      id,
      className = "",
      style,
      ...props
    },
    ref,
  ) => {
    const [focused, setFocused] = useState(false)
    const [internalValue, setInternalValue] = useState(defaultValue || "")
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`

    const isControlled = value !== undefined
    const inputValue = isControlled ? value : internalValue
    const isInvalid = error
    const isDisabled = disabled

    const handleChange = (e) => {
      if (isDisabled || readOnly) return

      if (!isControlled) {
        setInternalValue(e.target.value)
      }

      if (onChange) {
        onChange(e)
      }
    }

    const handleFocus = (e) => {
      if (isDisabled) return
      setFocused(true)
      if (onFocus) onFocus(e)
    }

    const handleBlur = (e) => {
      if (isDisabled) return
      setFocused(false)
      if (onBlur) onBlur(e)
    }

    const containerClasses = [
      styles.container,
      fullWidth && styles.fullWidth,
      className
    ].filter(Boolean).join(" ")

    const inputWrapperClasses = [
      styles.inputWrapper,
      styles[size],
      styles[variant],
      focused && styles.focused,
      isInvalid && styles.invalid,
      success && styles.success,
      warning && styles.warning,
      isDisabled && styles.disabled,
      readOnly && styles.readOnly,
    ].filter(Boolean).join(" ")

    const labelClasses = [
      styles.label,
      required && styles.required,
      isDisabled && styles.disabled,
    ].filter(Boolean).join(" ")

    return (
      <div className={containerClasses} style={style}>
        {label && (
          <label htmlFor={inputId} className={labelClasses}>
            {label}
            {/* {required && (
              <span className={styles.requiredIndicator} aria-hidden="true">
                *
              </span>
            )} */}
          </label>
        )}

        <div className={inputWrapperClasses}>
          <input
            ref={ref}
            id={inputId}
            name={name}
            type={type}
            className={styles.input}
            placeholder={placeholder}
            value={inputValue}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            disabled={isDisabled}
            readOnly={readOnly}
            required={required}
            {...props}
          />
        </div>

        {(error || warning || success || helperText) && (
          <div className={styles.messageContainer}>
            {error && (
              <div className={styles.errorMessage} role="alert">
                {error}
              </div>
            )}
            {warning && !error && <div className={styles.warningMessage}>{warning}</div>}
            {success && !error && !warning && <div className={styles.successMessage}>{success}</div>}
            {helperText && !error && !warning && !success && (
              <div className={styles.helperText}>
                {helperText}
              </div>
            )}
          </div>
        )}
      </div>
    )
  },
)

Input.displayName = "Input"

export default Input